import { Controller } from "stimulus";

const SPEED = 40; // px per second
const MAX_COPIES = 10;

export default class extends Controller {

  static get targets() {
    return [
      'track'
    ];
  }

  initialize() {
    if (!this.hasTrackTarget || this.trackTarget.children.length === 0) {
      return;
    }

    this.originals = [...this.trackTarget.children];
    this.offset = 0;
    this.raf = null;

    if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
      this.setup();
    }
  }

  setup() {
    this.fillTrack();

    // Image widths aren't known until they load, so re-measure once everything has
    window.addEventListener('load', () => this.fillTrack());
    window.addEventListener('resize', () => this.fillTrack());

    // Only animate while the carousel is on screen
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        entry.isIntersecting ? this.play() : this.pause();
      });
    });

    observer.observe(this.element);
  }

  // Clone the logos until the track covers the container plus one full loop,
  // so the wrap-around is seamless
  fillTrack() {
    const track = this.trackTarget;

    [...track.children].slice(this.originals.length).forEach(clone => clone.remove());

    this.addCopy();
    // The offset of the first clone gives the exact loop distance, gap included
    this.loopWidth = track.children[this.originals.length].offsetLeft - track.children[0].offsetLeft;

    if (this.loopWidth <= 0) {
      return;
    }

    let copies = 1;
    while (track.scrollWidth < this.element.offsetWidth + this.loopWidth && copies < MAX_COPIES) {
      this.addCopy();
      copies++;
    }

    this.offset = this.offset % this.loopWidth;
  }

  addCopy() {
    this.originals.forEach(item => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      this.trackTarget.appendChild(clone);
    });
  }

  play() {
    if (this.raf || !this.loopWidth) {
      return;
    }

    this.lastTime = null;

    const step = (time) => {
      if (this.lastTime !== null) {
        this.offset = (this.offset + SPEED * (time - this.lastTime) / 1000) % this.loopWidth;
        this.trackTarget.style.transform = `translateX(${-this.offset}px)`;
      }
      this.lastTime = time;
      this.raf = window.requestAnimationFrame(step);
    };

    this.raf = window.requestAnimationFrame(step);
  }

  pause() {
    if (this.raf) {
      window.cancelAnimationFrame(this.raf);
      this.raf = null;
    }
  }
};
